import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useContext, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, StyledInput } from '@ui';
import { InlineSwitch } from '@ui/InlineSwitch';
import InfoTooltip from '@ui/InfoTooltip';
import { useForm } from 'react-hook-form';
import FilterContext from '../Filter/FilterContext';

interface Props {
    filterName?: string;
    /** The whole of a name this row can only show the start of. */
    filterTooltip?: string;
    filterKey: string;
    filterPlaceholder?: string;
    callback?: () => void;
    size?: 'xs' | 'md';
    // Volle Spaltenbreite statt fixer 400px (Formular-Kontext)
    fullWidth?: boolean;
    enableInverted?: boolean;
}

export const TextFilter = ({
    filterName,
    filterTooltip,
    filterKey,
    callback,
    filterPlaceholder,
    size = 'xs',
    fullWidth = false,
    enableInverted = true
}: Props) => {
    const [filter, setFilter] = useContext(FilterContext);
    // full_text from the search bar is a bare string; RHF would write onto it and crash
    const current = typeof filter?.[filterKey] === 'object' ? filter[filterKey] : undefined;
    const { handleSubmit, register, reset } = useForm({ defaultValues: current });
    const inverted = current?.inverted ?? false;

    useEffect(() => {
        reset(current);
    }, [current, reset]);

    const handleSubmitFilter = (data) => {
        setFilter({ ...filter, [filterKey]: { ...data, inverted } });
        callback?.();
    };

    const resetFilter = () => {
        setFilter({ ...filter, [filterKey]: undefined });
        callback?.();
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
            <div
                className="tw-flex tw-items-baseline tw-gap-6 tw-px-2"
                style={{ minWidth: fullWidth || size !== 'xs' ? '100%' : 400 }}
            >
                {filterName && (
                    // The name is cut to 30% of the row and there was no way to
                    // read the rest of it. Same mark the date filter beside it
                    // already uses, and it appears only where a caller has
                    // something longer to say.
                    <b className="tw-flex tw-w-[30%] tw-shrink-0 tw-items-center tw-gap-1 tw-truncate tw-text-sm">
                        <span className="tw-truncate">{filterName}</span>
                        {filterTooltip && <InfoTooltip tooltip={filterTooltip} />}
                    </b>
                )}
                <StyledInput
                    {...register('value')}
                    bordered
                    fullWidth
                    placeholder={filterPlaceholder ?? 'Suchwert eingeben und mit dem Häkchen bestätigen...'}
                    color="success"
                    size={size}
                    className="!tw-my-0"
                    css={{ width: '100%' }}
                />
                {enableInverted && false && (
                    // disable inverted switch for now
                    <InlineSwitch onChange={() => {}} checked={inverted} className="tw-block tw-self-center" />
                )}
                <div className="tw-flex tw-gap-2">
                    <Button type="button" color="error" auto size={size} onPress={resetFilter}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                    <Button type="submit" color={filter?.[filterKey] ? 'warning' : 'success'} auto size={size}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                </div>
            </div>
        </form>
    );
};
